<template>
  <div class="exam-results">
    <div class="row">
      <!--   Go To Dashboard btn      -->
      <div class="col-md-12">
        <button @click="showDashboardClicked">Go back to the dashboard</button>
      </div>

      <!--   Overall Results         -->
      <div class="col-md-12">
        <p>
          <span>You have</span>
          <span v-text="passedStatus"></span>
        </p>
        <p>
          <span>Your score is</span>
          <span v-text="' ' + exam_results.total.score + '%, '"></span>
          <span>with</span>
          <span
            v-text="' ' + exam_results.total.total_wrong_answers + ' '"
          ></span>
          <span>wrong answers.</span>
        </p>

        <div v-show="exam_details.is_simulation === 1">
          <p v-show="exam_results.total.not_fully_answered_count">
            <span>Unfortunately, </span>
            <span
              v-text="' ' + exam_results.total.not_fully_answered_count"
            ></span>
            <span
              >of your wrong answers were because you selected only one answer
              in a question that required more than one, which is a very common
              mistake.&nbsp;</span
            >
            <span>Your score could be</span>
            <span
              v-text="' ' + exam_results.total.score_if_fully_answered"
            ></span>
            <span>% if you answered these questions correctly.</span>
          </p>

          <p v-show="exam_results.total.not_answered_count">
            You've left
            <span v-text="exam_results.total.not_answered_count"></span>
            questions unanswered, while there's no penalty for wrong answers and
            it's best if you answer&nbsp;all.
          </p>
        </div>

        <br />
      </div>
    </div>

    <categorized-results
      v-if="exam_details.show_breakdown === 1"
      :results="exam_results.categorized"
    />
    <br />

    <!--  Detailed Feedback Button      -->
    <div class="row" v-if="exam_results.total.can_review === 1">
      <div class="col-md-12">
        <button
          @click="
            showReviewPanel({
              exam_instance_id: exam_results.total.exam_instance_id
            })
          "
        >
          Detailed feedback
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CategorizedResults from "./CategorizedResults";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    CategorizedResults
  },
  computed: {
    ...mapState("results", ["exam_results"]),
    ...mapState("exam", ["exam_details"]),

    passedStatus() {
      if (
        this.exam_results.total.score >= this.exam_results.total.passing_score
      ) {
        return " passed!";
      } else {
        return " failed!";
      }
    }
  },

  methods: {
    ...mapActions(["showDashboardClicked", "showReviewPanel"])
  }
};
</script>
